<section class=" page-banner">
    <div class=" opacity-banner" >
        <div class="pt-5 mt-5 ">
            <div class="container  h-100">
                <h1 class="fw-bolder text-center text-blue ">
                    <span class="pt-5 mt-5 d-none d-md-block font-56">Transforming Online Presence with Intuitive Web Development Services</span>
                    <span class="d-md-none ">Transforming Online Presence with Intuitive Web Development Services</span>
                </h1>
                <p class="text-white fw-bold  fs-6 w-75 mx-auto">Your website serves the first impression of your business, let’s build a powerful online presence with Volmint’s custom web design and development services tailored to your unique business needs to craft your success story together!
                </p>
            </div>
        </div>

    </div>
</section>
<div class="container-fluid bg-blue">
    <div class="container text-center  py-4">

        <div class="col-12 text-center">
            <h2 class=" fs-1 text-white fw-bolder">About Volmint’s
                <span class=""> Web Development Services</span></h2>
            <p class="my-0 fs-6 text-white text-wrap justify-text">Volmint Technologies, a website development company specializes in delivering unique web solutions that are designed as per business requirements. From engaging front-end designs to robust back-end systems, we ensure highly effective designs that drive better user experience, enhance engagement and growth.
            </p>
            <p class="my-0  fs-6 text-white text-wrap justify-text">Whether you need a fully functional web application or a visually stunning website, we use creative and powerful methods to realize your vision. With advanced tools and a team of exceptional individuals, we ensure to creation of customizable and powerful websites that load fast.
            </p>
            <p class="my-0 fs-6 text-white text-wrap justify-text">We give users an immersive experience by using carefully chosen graphics, distinctively designed sites, engaging material on each page, and simple navigation. We take pride in offering our clients some of the best custom web design and development services on the market right now.
            </p>
        </div>
    </div>
</div>

<div class="container-fluid banner-img-2 " style="background: #eff5f9">
    <div class="container py-5">
        <div class="row">
            <div class="col-12 col-md-4 ps-md-5 py-md-5 py-4 align-self-center ">
                <h2 class=" fs-1 fw-bolder">Comprehensive <span class="text-blue"> Web Development Services</span> We Offer</h2>
            </div>
            <div class="row d-md-none px-0 mx-auto w-100 ">
                    <div class="col-12 p-3 col-md-6 ">
                    <div class=" shadow bg-blue h-100 p-3">
                        <div class="border shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="fas fa-palette fs-3 text-white"></i>
                        </div>
                        <h3 class="text-white mt-2">
                            Front-End Development
                        </h3>
                        <p class="text-white">Focus on intuitive UI/UX design, we create visually impactful websites using appropriate colors, font, images, icons, and types. We use angular web development technology for dynamic interfaces.
                        </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="p-3 bg-white h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fas fa-server fs-3"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Back-End Development
                        </h3>
                        <p class="text-muted">
                            To strengthen your online presence, secure and scalable server-side, we use API integration, laravel web tech, and Node.js for better functionality and optimization.                                                    </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="p-3 bg-white h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fs-3 fas fa-laptop-code	"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Full Stack Web Development Services
                        </h3>
                        <p class="text-muted">
                            We provide highly effective websites by combining both front-end and back-end skills. Full-stack development services ensure database management and server-side scripting.
                        </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="bg-white p-3 h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fs-3 fas fa-puzzle-piece"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Custom Web Development Services
                        </h3>
                        <p class="text-muted">
                            We ensure that your website portrays the style and uniqueness of your business. Thus, we create and develop a user-friendly website with seamless navigation and high functionality.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row d-md-none px-0 mx-auto w-100 pt-2">
                <div class=" col-12 p-3 col-md-6 ">
                    <div class=" shadow bg-blue h-100 p-3">
                        <div class="border shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="fas fa-shopping-cart fs-3 text-white"></i>
                        </div>
                        <h3 class="text-white mt-2">
                            E-Commerce Solutions
                        </h3>
                        <p class="text-white">
                            We create secure and scalable E-Commerce platforms tailored to your business needs that ensure a hassle-free shopping experience.
                        </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="p-3 bg-white h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fas fa-tools	 fs-3"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Maintenance and Support
                        </h3>
                        <p class="text-muted">
                            Appropriate maintenance is a must to be competitive in a market. We just don’t develop a website, we ensure the website runs smoothly with our dedicated maintenance and support services.
                        </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="p-3 bg-white h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fs-3 fa fa-desktop		"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Web App Development
                        </h3>
                        <p class="text-muted">
                            Web apps are the demand by modern users, our web app solutions are designed to deliver a seamless user interface and user experience to enhance functionality and drive business growth.
                        </p>
                    </div>
                </div>
                <div class="col-12 p-3 col-md-6">
                    <div class="bg-white p-3 h-100">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="text-blue fs-3 fa fa-sync-alt	"></i>
                        </div>
                        <h3 class="text-muted mt-2">
                            Website Redesign
                        </h3>
                        <p class="text-muted">
                            Managing your website design, content, and consistency can be a complex task and outdated layouts may reduce the website performance. We create responsive design and keep your site updated.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-12 d-none d-md-block col-md-8">
                <div class="">
                    <div class=" row pt-5   ">
                        <div class="col-1 d-flex justify-content-end">
                            <div class="carousel-buttons align-self-center d-flex pe-0 flex-column">
                                <button class=" fs-5 fw-bold" (click)="prevSlide()">
                                    <i class="fas mx fa-arrow-up"></i>
                                </button>
                                <button class=" fs-5 fw-bold" (click)="nextSlide()">
                                    <i class="fas mx fa-arrow-down"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-11">
                            <div class="carousel-container">
                                <div class="carousel"
                                     [style.transform]="'translateY(-' + currentIndex * itemHeight + 'px)'"
                                     [style.transition]="'transform 0.5s ease-in-out'">
                                    <div class="carousel-item h-100">
                                        <div class="row mx-auto w-100 ">
                                            <div class="col-12 p-3 col-md-6 ">
                                                <div class=" shadow bg-blue h-100 p-3">
                                                    <div class="border shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="fas fa-palette fs-3 text-white"></i>
                                                    </div>
                                                    <h3 class="text-white mt-2">
                                                        Front-End Development
                                                    </h3>
                                                    <p class="text-white">Focus on intuitive UI/UX design, we create visually impactful websites using appropriate colors, font, images, icons, and types. We use angular web development technology for dynamic interfaces.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="p-3 bg-white h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fas fa-server fs-3"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Back-End Development
                                                    </h3>
                                                    <p class="text-muted">
                                                        To strengthen your online presence, secure and scalable server-side, we use API integration, laravel web tech, and Node.js for better functionality and optimization.                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="p-3 bg-white h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fs-3 fas fa-laptop-code	"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Full Stack Web Development Services
                                                    </h3>
                                                    <p class="text-muted">
                                                        We provide highly effective websites by combining both front-end and back-end skills. Full-stack development services ensure database management and server-side scripting.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="bg-white p-3 h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fs-3 fas fa-puzzle-piece"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Custom Web Development Services
                                                    </h3>
                                                    <p class="text-muted">
                                                        We ensure that your website portrays the style and uniqueness of your business. Thus, we create and develop a user-friendly website with seamless navigation and high functionality.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item h-100 ">
                                        <div class="row mx-auto w-100 pt-3">
                                            <div class=" col-12 p-3 col-md-6 ">
                                                <div class=" shadow bg-blue h-100 p-3">
                                                    <div class="border shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="fas fa-shopping-cart fs-3 text-white"></i>
                                                    </div>
                                                    <h3 class="text-white mt-2">
                                                        E-Commerce Solutions
                                                    </h3>
                                                    <p class="text-white">
                                                        We create secure and scalable E-Commerce platforms tailored to your business needs that ensure a hassle-free shopping experience.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="p-3 bg-white h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fas fa-tools	 fs-3"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Maintenance and Support
                                                    </h3>
                                                    <p class="text-muted">
                                                        Appropriate maintenance is a must to be competitive in a market. We just don’t develop a website, we ensure the website runs smoothly with our dedicated maintenance and support services.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="p-3 bg-white h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fs-3 fa fa-desktop		"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Web App Development
                                                    </h3>
                                                    <p class="text-muted">
                                                        Web apps are the demand by modern users, our web app solutions are designed to deliver a seamless user interface and user experience to enhance functionality and drive business growth.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 p-3 col-md-6">
                                                <div class="bg-white p-3 h-100">
                                                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                                                        <i class="text-blue fs-3 fa fa-sync-alt	"></i>
                                                    </div>
                                                    <h3 class="text-muted mt-2">
                                                        Website Redesign
                                                    </h3>
                                                    <p class="text-muted">
                                                        Managing your website design, content, and consistency can be a complex task and outdated layouts may reduce the website performance. We create responsive design and keep your site updated.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<section class="py-5">
    <div class="container">
        <h2 class="text-center fw-bold mb-5">
            Why Choose <span class="text-blue">Volmint’s Website Design Service?</span>
        </h2>

        <div class="row gy-5 ">

            <!-- Responsive Web Design -->
            <div class="col-md-6 col-lg-4">
                <div class="d-flex align-items-start">
                    <i class="fas fa-laptop-code fa-2x text-blue me-3"></i>
                    <div>
                        <h5 class="fw-semibold">Responsive Web Design</h5>
                        <p class="text-muted">
                            We create adaptive websites accessible on any device—laptop, tablet, or phone—ensuring a flawless user experience anytime, anywhere.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Fast Loading Speed -->
            <div class="col-md-6 col-lg-4">
                <div class="d-flex align-items-start">
                    <i class="fas fa-tachometer-alt fa-2x text-blue me-3"></i>
                    <div>
                        <h5 class="fw-semibold">Fast Loading Speed</h5>
                        <p class="text-muted">
                            Prioritizing speed to ensure your website loads quickly even during high traffic, boosting both UX and search engine rankings.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Seamless User Experience -->
            <div class="col-md-6 col-lg-4">
                <div class="d-flex align-items-start">
                    <i class="fas fa-users fa-2x text-blue me-3"></i>
                    <div>
                        <h5 class="fw-semibold">Seamless User Experience</h5>
                        <p class="text-muted">
                            We design intuitive layouts that simplify navigation, enhance engagement, and keep visitors connected with your brand.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Custom-Tailored Solutions -->
            <div class="col-md-6 col-lg-4">
                <div class="d-flex align-items-start">
                    <i class="fas fa-puzzle-piece fa-2x text-blue me-3"></i>
                    <div>
                        <h5 class="fw-semibold">Custom-Tailored Solutions</h5>
                        <p class="text-muted">
                            Unique designs crafted to match your business goals, created by a passionate team focused on delivering your brand identity.
                        </p>
                    </div>
                </div>
            </div>

            <!-- SEO-Ready Design -->
            <div class="col-md-6 col-lg-4">
                <div class="d-flex align-items-start">
                    <i class="fas fa-search fa-2x text-blue me-3"></i>
                    <div>
                        <h5 class="fw-semibold">SEO-Ready Design</h5>
                        <p class="text-muted">
                            Beyond good looks—we build SEO-centric websites for better visibility and organic traffic growth from the ground up.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<section class="py-5" style="background: #eff5f9;">
    <div class="container">
        <h2 class="text-center fw-bold mb-4">
            Website Development Roadmap
        </h2>
        <p class="text-center mb-5 text-muted">
            Our Unique Approach and Procedure
        </p>

        <div class="row g-4">

            <!-- Step 1 -->
            <div class="col-md-12">
                <div class="card border-0 shadow-sm p-4 mb-4 d-flex flex-md-row align-items-center">
                    <div class="flex-shrink-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; font-size: 1.5rem;">
                        1
                    </div>
                    <div class="ms-md-4 mt-3 mt-md-0">
                        <h5 class="fw-semibold">We Identify Your Needs</h5>
                        <p class="text-muted mb-0">
                            Understanding your organization's unique requirements and business objectives to set the foundation for a successful web project.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="col-md-12">
                <div class="card border-0 shadow-sm p-4 mb-4 d-flex flex-md-row align-items-center">
                    <div class="flex-shrink-0 bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; font-size: 1.5rem;">
                        2
                    </div>
                    <div class="ms-md-4 mt-3 mt-md-0">
                        <h5 class="fw-semibold">Tailored Solutions for Your Success</h5>
                        <p class="text-muted mb-0">
                            Crafting custom websites that engage and captivate, ensuring a design that retains customers.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="col-md-12">
                <div class="card border-0 shadow-sm p-4 mb-4 d-flex flex-md-row align-items-center">
                    <div class="flex-shrink-0 bg-warning text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; font-size: 1.5rem;">
                        3
                    </div>
                    <div class="ms-md-4 mt-3 mt-md-0">
                        <h5 class="fw-semibold">Ensuring Accessibility for Everyone</h5>
                        <p class="text-muted mb-0">
                            Focusing on exceptional UI & UX to connect with a diverse audience, ensuring ease of use.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div class="col-md-12">
                <div class="card border-0 shadow-sm p-4 mb-4 d-flex flex-md-row align-items-center">
                    <div class="flex-shrink-0 bg-danger text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; font-size: 1.5rem;">
                        4
                    </div>
                    <div class="ms-md-4 mt-3 mt-md-0">
                        <h5 class="fw-semibold">Speed and Performance Optimization</h5>
                        <p class="text-muted mb-0">
                            Optimizing your website for top-notch performance and fast loading on all devices.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 5 -->
            <div class="col-md-12">
                <div class="card border-0 shadow-sm p-4 d-flex flex-md-row align-items-center">
                    <div class="flex-shrink-0 bg-info text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; font-size: 1.5rem;">
                        5
                    </div>
                    <div class="ms-md-4 mt-3 mt-md-0">
                        <h5 class="fw-semibold">Seamless Website Launch</h5>
                        <p class="text-muted mb-0">
                            Launching your website on schedule with results that exceed expectations.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<section class="py-5 bg-white">
    <div class="container">
        <h2 class="text-center fw-bold mb-4">
            Changes Volmint’s Web Development Services Brings To Your Website
        </h2>
        <p class="text-center text-muted mb-5">
            Transforming your online presence with impactful, user-focused solutions.
        </p>

        <div class="row g-4">

            <div class="col-md-6 col-lg-4">
                <div class="card h-100 shadow-sm border-0 p-4 text-center">
                    <div class="mb-3">
                        <i class="fas fa-bullhorn fa-3x text-blue"></i>
                    </div>
                    <h5 class="fw-semibold">Increase Web Presence</h5>
                    <p class="text-muted">
                        Tailored web solutions to boost visibility, strengthen your brand, and build authority online.
                    </p>
                </div>
            </div>

            <div class="col-md-6 col-lg-4">
                <div class="card h-100 shadow-sm border-0 p-4 text-center">
                    <div class="mb-3">
                        <i class="fas fa-users fa-3x text-blue"></i>
                    </div>
                    <h5 class="fw-semibold">Increased User Engagement</h5>
                    <p class="text-muted">
                        Intuitive designs that keep visitors hooked and encourage interaction with your content.
                    </p>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="col-md-6 col-lg-4">
                <div class="card h-100 shadow-sm border-0 p-4 text-center">
                    <div class="mb-3">
                        <i class="fas fa-smile-beam fa-3x text-blue"></i>
                    </div>
                    <h5 class="fw-semibold">Boost Customer Satisfaction</h5>
                    <p class="text-muted">
                        Fast, responsive, and user-friendly experiences that turn visitors into loyal customers.
                    </p>
                </div>
            </div>

            <!-- Card 4 -->
            <div class="col-md-6 col-lg-6">
                <div class="card h-100 shadow-sm border-0 p-4 text-center">
                    <div class="mb-3">
                        <i class="fas fa-chart-line fa-3x text-blue"></i>
                    </div>
                    <h5 class="fw-semibold">Get Potential Leads</h5>
                    <p class="text-muted">
                        Optimized layouts and calls to action that turn visitors into valuable business opportunities.
                    </p>
                </div>
            </div>

            <!-- Card 5 -->
            <div class="col-md-6 col-lg-6">
                <div class="card h-100 shadow-sm border-0 p-4 text-center">
                    <div class="mb-3">
                        <i class="fas fa-cogs fa-3x text-blue"></i>
                    </div>
                    <h5 class="fw-semibold">Streamlined Processes</h5>
                    <p class="text-muted">
                        Smart integrations that automate workflows, saving your team time and effort.
                    </p>
                </div>
            </div>

        </div>
    </div>
</section>
<section class="py-5 bg-light">
    <div class="container">
        <h2 class="text-center fw-bold mb-5">Technologies We Have Expertise In</h2>

        <!-- Front-End -->
        <h4 class="fw-semibold text-blue mb-4">Front-End</h4>
        <div class="row g-4 align-items-center">

            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/html.png" alt="HTML" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/css.png" alt="CSS" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/js.png" alt="JavaScript" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/bootstrap.png" alt="Bootstrap" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/tailwindcss.png" alt="Tailwind CSS" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/jquery.png" alt="jQuery" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/angular.png" alt="Angular" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/react.png" alt="React" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/socket-io.png" alt="Socket.IO" class="img-fluid" style="height:50px;">
            </div>

        </div>

        <!-- Back-End -->
        <h4 class="fw-semibold text-blue mt-5 mb-4">Back-End</h4>
        <div class="row g-4 align-items-center">

            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/laravel.png" alt="Laravel" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/nodejs.png" alt="NodeJS" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/php.png" alt="PHP" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/mysql.png" alt="SQL" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/mongodb.png" alt="NoSQL" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/redis.png" alt="Redis" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/aws.png" alt="AWS" class="img-fluid" style="height:50px;">
            </div>
            <div class="col-4 col-md-2 text-center">
                <img src="assets/img/landing-new/website-development/python.png" alt="Python" class="img-fluid" style="height:50px;">
            </div>

        </div>
    </div>
</section>

<div class="container-fluid px-0 technology-bg ">
    <div class="container-fluid py-5"
         style="background: rgba(16,23,56,0.46);">
        <div class="py-5 ">
            <div class="container">
                <h2 class="text-center fw-bold mb-5 text-white">Front-End vs. Back-End Website Development</h2>

                <div class="row g-4">

                    <!-- Front-End Card -->
                    <div class="col-md-6">
                        <div class="card h-100 shadow-lg border-0">
                            <div class="card-body p-4">
                                <h3 class="text-blue fw-bold mb-3"><i class="bi bi-display"></i> Front-End Development</h3>
                                <ul class="list-unstyled">
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Focuses on user-facing elements</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Design intuitive and engaging interfaces</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Ensures responsive designs for all devices</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Implements animations and interactivity</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Uses technologies like HTML, CSS, Angular, and JavaScript</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Back-End Card -->
                    <div class="col-md-6">
                        <div class="card h-100 shadow-lg border-0">
                            <div class="card-body p-4">
                                <h3 class="text-blue fw-bold mb-3"><i class="bi bi-server"></i> Back-End Development</h3>
                                <ul class="list-unstyled">
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Manages server-side functionality</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Handles databases and application logic</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Ensures security and scalability</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Integrates third-party APIs and services</li>
                                    <li class="mb-2"><i class="bi bi-check-circle text-success me-2"></i> Uses frameworks like Laravel and Node.js</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</div>


<div class="container-fluid my-4 py-4">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <h2 class="fs-1 fw-bold">Frequently Asked Questions</h2>
                    <p class="text-secondary">Have a question that is not answered? You can contact us at</p>
                    <p class="brand-primary-text-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                          class="text-decoration-underline brand-primary-text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="bg-blue border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                <span class="fs-6 fw-bold text-blue">
                    <div class="encircled-icon">
                        <i class="fas fa-question fw-bold"></i>
                    </div>
                    &nbsp;What Makes Volmint’s Web Development Services Stand Out?
                </span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Volmint Technologies specializes in creating tailored web solutions that reflect your unique business needs. From visually appealing front-end designs to robust back-end functionalities, our expertise ensures websites that enhance user experience, engagement, and business growth.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                <span class="fs-6 fw-bold text-blue">
                    <div class="encircled-icon">
                        <i class="fas fa-question fw-bold"></i>
                    </div>
                    &nbsp;What Technologies Does Volmint Use for Web Development?
                </span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We leverage advanced tools and technologies like HTML, CSS, Angular, Laravel, Node.js, and SQL/NoSQL databases. Whether for front-end interactivity or back-end scalability, we ensure a seamless, secure, and high-performing digital experience.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                <span class="fs-6 fw-bold text-blue">
                    <div class="encircled-icon">
                        <i class="fas fa-question fw-bold"></i>
                    </div>
                    &nbsp;How Does Volmint Improve User Engagement on Websites?
                </span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We design intuitive interfaces with seamless navigation, fast-loading pages, and responsive designs. These features keep users engaged and satisfied, increasing their likelihood of staying on your site and interacting with your content.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                <span class="fs-6 fw-bold text-blue">
                    <div class="encircled-icon">
                        <i class="fas fa-question fw-bold"></i>
                    </div>
                    &nbsp;What Benefits Can I Expect from Volmint’s Web Development Services?
                </span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Our services boost your online presence, enhance customer satisfaction, and attract potential leads. By integrating smart workflows and automated processes, we ensure efficiency, saving time and resources for your business.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                <span class="fs-6 fw-bold text-blue">
                    <div class="encircled-icon">
                        <i class="fas fa-question fw-bold"></i>
                    </div>
                    &nbsp;Why Choose Volmint for E-Commerce or CMS Development?
                </span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Volmint creates secure, scalable e-commerce platforms tailored to your business. For CMS, we design responsive platforms allowing easy content updates without technical expertise, ensuring a user-friendly, efficient, and effective solution for managing your website.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-blue ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class="btn bg-white rounded-0 px-5 py-3 text-black fw-bold "
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>










